import { render, staticRenderFns } from "./dismiss_agreement.vue?vue&type=template&id=388a59d0"
import script from "./dismiss_agreement.vue?vue&type=script&lang=js"
export * from "./dismiss_agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports